module.exports = __webpack_public_path__ + "img/logo_small.20106a86.svg";